import { DateTime } from 'luxon';

import { dateFilterOperators } from '../../containers/base-filter-bar-container/reference-data-criteria-arguments';

export const calculateTargetDatetimesFromOperator = (dateOperator, sellerTimeZone, startDate, endDate) => {
  switch (dateOperator) {
    case dateFilterOperators.dateToday:
      return {
        startDate: DateTime.now().setZone(sellerTimeZone).startOf('day').toUTC().toISO(),
        endDate: DateTime.now().setZone(sellerTimeZone).endOf('day').toUTC().toISO(),
      };
    case dateFilterOperators.dateYesterday:
      return {
        startDate: DateTime.now().setZone(sellerTimeZone).minus({ days: 1 }).startOf('day').toUTC().toISO(),
        endDate: DateTime.now().setZone(sellerTimeZone).minus({ days: 1 }).endOf('day').toUTC().toISO(),
      };
    case dateFilterOperators.dateLastWeek:
      return {
        startDate: DateTime.now().setZone(sellerTimeZone).minus({ days: 6 }).startOf('day').toUTC().toISO(),
        endDate: DateTime.now().setZone(sellerTimeZone).endOf('day').toUTC().toISO(),
      };
    case dateFilterOperators.dateLast30Days:
      return {
        startDate: DateTime.now().setZone(sellerTimeZone).minus({ days: 30 }).startOf('day').toUTC().toISO(),
        endDate: DateTime.now().setZone(sellerTimeZone).endOf('day').toUTC().toISO(),
      };
    case dateFilterOperators.dateThisMonth:
      return {
        startDate: DateTime.now().setZone(sellerTimeZone).startOf('month').toUTC().toISO(),
        endDate: DateTime.now().setZone(sellerTimeZone).endOf('month').toUTC().toISO(),
      };
    case dateFilterOperators.dateLastMonth:
      return {
        startDate: DateTime.now().setZone(sellerTimeZone).minus({ months: 1 }).startOf('month').toUTC().toISO(),
        endDate: DateTime.now().setZone(sellerTimeZone).minus({ months: 1 }).endOf('month').toUTC().toISO(),
      };
    default:
      return {
        startDate,
        endDate,
      };
  }
};
